/** Display labels for template categories (mirrors campaign seed + @brushfire/types). */
const TEMPLATE_CATEGORY_LABELS: Record<string, string> = {
  brand_creative: 'Brand & Creative',
  pricing_value: 'Pricing & Value',
  customer_experience: 'Customer Experience',
  product_feature: 'Product & Feature',
}

export function getTemplateCategoryLabel(category: string | undefined): string {
  if (!category) return ''
  return TEMPLATE_CATEGORY_LABELS[category] ?? category.replaceAll('_', ' ')
}
